import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmModal, Text } from '@cashfree-intl/coherent';

import { RESET_PAYPAL_MODAL } from '../constants';

const ResetPaymentMethod = ({ modalName, resetPaymentMethod, closeModal }) => (
  <ConfirmModal
    title={
      modalName === RESET_PAYPAL_MODAL
        ? 'Deactivate Paypal'
        : 'Deactivate Paytm Wallet'
    }
    danger
    confirmText="Deactivate"
    onClose={closeModal}
    onConfirm={() => resetPaymentMethod(modalName)}
    confirmBtnEvent={`Danger_Button_${
      modalName === RESET_PAYPAL_MODAL
        ? 'Deactivate_Paypal'
        : 'Deactivate_Paytm_Wallet'
    }_Confirm`}
    closeBtnEvent={`Link_Button_${
      modalName === RESET_PAYPAL_MODAL
        ? 'Deactivate_Paypal'
        : 'Deactivate_Paytm_Wallet'
    }_Cancel`}
    closeCrossEvent={`${
      modalName === RESET_PAYPAL_MODAL
        ? 'Deactivate_Paypal'
        : 'Deactivate_Paytm_Wallet'
    }_Icon_Close`}
  >
    <Text variant="b14" color="bodyLight">
      Are you sure you want to deactivate{' '}
      {modalName === RESET_PAYPAL_MODAL ? 'Paypal' : 'Paytm Wallet'}?
    </Text>
    <Text className="mr-top-16" variant="b14" color="warning">
      You will have to connect your{' '}
      {modalName === RESET_PAYPAL_MODAL ? 'PayPal account' : 'Paytm Wallet'}{' '}
      again if you wish to re-activate this payment mode in the future.
    </Text>
  </ConfirmModal>
);

ResetPaymentMethod.propTypes = {
  modalName: PropTypes.string.isRequired,
  resetPaymentMethod: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default ResetPaymentMethod;
